export default __webpack_public_path__ + "static/media/sadnice.edf0e077.jpg";